import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installGlobalChunkReloadHandler } from "./lib/chunkReload";
import { initTheme } from "./lib/theme";

// Catch lazy-import failures that escape React's error boundary (e.g. thrown
// from event handlers or effects after a deploy invalidated chunk hashes).
installGlobalChunkReloadHandler();

// Paint the stored light/dark choice before first render so there is no flash.
initTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
